export const Filters = {
    email: 'email',
    firstName: 'firstName',
    lastName: 'lastName',
    roleName: 'roleName',
    roleId: 'roleId',
    status: 'status',
    lastLogin: 'lastLogin'
};

export const enum Status {
    Active = 'Active',
    Inactive = 'Inactive',
    Pending = 'Pending',
    Banned = 'Banned'
};

export const single = [
    Filters.status
];

export const multi = [
    Filters.roleId
];

export const text = [
    Filters.email,
    Filters.firstName,
    Filters.lastName
];
